import React, { useEffect, useState } from 'react';
import { Paper, Skeleton, LinearProgress, Grid, Tooltip } from '@mui/material';
import InterpreterModeIcon from '@mui/icons-material/InterpreterMode';
// import { getRatio } from 'api/sentinelAPI';
import { useSelector } from 'react-redux';
import GroupIcon from '@mui/icons-material/Group';
import { useTheme } from '@mui/material/styles';
import NoDataImg from '../../../assets/images/No_data-amico.svg';
import { customerAssociateRatio, interactionNumbers } from 'api/sentinelAPI';

function Rightbar() {
  const [cusAssRatio, setCusAssRatio] = useState(false);
  const [cusAssRatioData, setCusAssRatioData] = useState(false);
  const [attended, setAttended] = useState(false);
  const [unAttended, setUnAttended] = useState(false);
  const [interactionData, setInteractionData] = useState(false);
  
  // Dummy data for demographics
  const [maleData, 
    // setMaleData
  ] = useState({
    kid: 11,     
    teen: 15,    
    adult: 29,   
    elderly: 5   
  });
  const [femaleData, 
    // setFemaleData
  ] = useState({
    kid: 9,      
    teen: 13,    
    adult: 24,   
    elderly: 7   
  });
  const [totalMale, setTotalMale] = useState(60);
  const [totalFemale, setTotalFemale] = useState(53);

  // Verify combined total: 60 (male) + 53 (female) = 113
  // Verify maleData sum: 11 + 15 + 29 + 5 = 60
  // Verify femaleData sum: 9 + 13 + 24 + 7 = 53
  const theme = useTheme();
  const date = useSelector((state) => state.customization.currentDate);

  const selectedTime = useSelector((state) => state.customization.selectedTime);
  const startTime = new Date(selectedTime.start_time);
  const endTime = new Date(selectedTime.end_time);

  const formattedStartTimeIST = startTime.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }).split(',')[1];
  const formattedEndTimeIST = endTime.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }).split(',')[1];

  const [isMounted, setIsMounted] = useState(false);

  async function getCustomerAssociateRatio(commonBody, signal) {
    try {
      const data = await customerAssociateRatio(commonBody, { signal });

      if (!signal.aborted) {
        if (!data || data.length === 0) {
          setCusAssRatio(false);
          setCusAssRatioData(false);
        } else if (data && data.length > 0) {
          const cusCounts = data.map((obj) => obj.customer_count);
          const totalCus = cusCounts.reduce((acc, val) => acc + val, 0);
          const empCounts = data.map((obj) => obj.employee_count);
          const totalEmp = empCounts.reduce((acc, val) => acc + val, 0);
          const avgRatio = (totalCus / totalEmp).toFixed(2);
          // const avgRatio = data.result;
          const countData = data;
          setCusAssRatio(avgRatio);
          setCusAssRatioData(countData);
        }
      }
    } catch (error) {
      if (!signal.aborted) {
        setCusAssRatio(false);
        setCusAssRatioData(false);
        console.log(error);
      }
    }
  }

  async function getInteractionNumbers(commonBody, signal) {
    try {
      const data = await interactionNumbers(commonBody, { signal });

      if (!signal.aborted) {
        if (!data || data.length === 0) {
          setAttended(false);
          setUnAttended(false);
          setInteractionData(false);
        } else if (data && data.length > 0) {
          const attendedValues = data.map((obj) => obj.interacted);
          const attendedSum = attendedValues.reduce((acc, val) => acc + val, 0);
          const unAttendedValues = data.map((obj) => obj.not_interacted);
          const unAttendedSum = unAttendedValues.reduce((acc, val) => acc + val, 0);
          // const avgTime = sum / attendedValues.length;
          // const avgRatio = data.result;
          const zoneWise = data;
          setAttended(attendedSum);
          setUnAttended(unAttendedSum);
          setInteractionData(zoneWise);
        }
        // console.log('Avg Waiting Time', data);
      }
    } catch (error) {
      if (!signal.aborted) {
        setAttended(false);
        setUnAttended(false);
        setInteractionData(false);
        console.log(error);
      }
    }
  }

  useEffect(() => {
    setIsMounted(true);

    return () => {
      setIsMounted(false);
    };
  }, []);

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;

    if (isMounted) {
      const commonBody = {
        start_time: formattedStartTimeIST,
        end_time: formattedEndTimeIST,
        start_date: date,
        storeId: '65c5e26a0b5be5dc7af327dc'
      };

      getCustomerAssociateRatio(commonBody, signal);
      getInteractionNumbers(commonBody, signal);
      
      // Calculate totals from dummy data
      const maleTotal = Object.values(maleData).reduce((sum, value) => sum + value, 0);
      const femaleTotal = Object.values(femaleData).reduce((sum, value) => sum + value, 0);
      setTotalMale(maleTotal);
      setTotalFemale(femaleTotal);
    }

    return () => {
      abortController.abort();
    };
  }, [date, isMounted, formattedStartTimeIST, formattedEndTimeIST]);

  cusAssRatioData && cusAssRatioData.sort((a, b) => b.customer_count / b.employee_count - a.customer_count / a.employee_count);
  interactionData && interactionData.sort((a, b) => a.interacted - b.interacted);

  const paperStyle = {
    width: '100%',
    maxHeight: '280px',
    height: '280px',
    padding: '10px',
    marginBottom: '11.5px',
    position: 'relative',
    left: 'auto',
    borderRadius: '15px',
    display: 'flex',
    alignItems: 'center',
    flex: '1'
  };

  const paperStyleLastCard = {
    width: '100%',
    maxHeight: '400px',
    height: '290px',
    padding: '10px',
    marginBottom: '11.5px',
    position: 'relative',
    left: 'auto',
    borderRadius: '15px',
    display: 'flex',
    // alignItems: 'center',
    flex: '1'
  };

  return (
    <>
      <Grid
        item
        xs={12}
        // md={3}
        // sm={6}
        sx={{
          width: '100%',
          // height:'100px',
          mb: -1,
          mt: 1,
          [theme.breakpoints.up('sm')]: {
            mb: -1,
            mt: 1 // Height for screens equal to or larger than 'md' breakpoint
          },
          [theme.breakpoints.up('md')]: {
            mb: -1,
            mt: -1 // Height for screens equal to or larger than 'md' breakpoint
          }
        }}
      >
        <Paper elevation={3} sx={paperStyle}>
          {cusAssRatioData && cusAssRatioData.length > 0 ? (
            <div className="flex  w-full  flex-col gap-1">
              <div className="flex items-center justify-center gap-2 w-full">
                {cusAssRatioData ? (
                  <GroupIcon className="bg-[#444444] text-white rounded-full p-2 text-5xl" />
                ) : (
                  <Skeleton variant="circular" width={60} height={45} />
                )}
                <div className="w-full">
                  {cusAssRatioData ? (
                    <p className="text-3xl">1 : {cusAssRatio}</p>
                  ) : (
                    <Skeleton variant="rectangular" className="mb-3 rounded-sm" width={50} height={20} />
                  )}

                  {cusAssRatioData ? (
                    <p>
                      <span className="text-[1.090rem]">Employee : Customer</span>
                    </p>
                  ) : (
                    <Skeleton variant="rectangular" width={150} height={15} className=" mb-2 rounded-sm" />
                  )}
                </div>
              </div>
              {cusAssRatioData ? (
                <div className=" bg-slate-100 flex-grow overflow-y-auto h-[184px] p-2 rounded-lg scrollbar">
                  {cusAssRatioData.map((item, index) => {
                    const highestFootfall = cusAssRatioData.reduce((maxFootfall, item) => {
                      return item.customer_count / item.employee_count > maxFootfall
                        ? item.customer_count / item.employee_count
                        : maxFootfall;
                    }, 0);
                    const percentage = ((item.customer_count / item.employee_count / highestFootfall) * 100).toFixed(1);
                    const barcolor = percentage >= 80 ? '#ff413a' : percentage >= 50 ? '#f4a100' : '#00ac69';
                    return (
                      <div className="mt-2" key={index}>
                        <div className="flex gap-1 items-center">
                          <div
                            className=" rounded-full size-3"
                            style={{
                              // backgroundColor: ${item.zoneColourHex}
                              backgroundColor: '#06b6d4'
                            }}
                          >
                            {' '}
                          </div>
                          <div>
                            {item._id} - 1 : {(item.customer_count / item.employee_count).toFixed(2)}
                          </div>
                        </div>
                        <LinearProgress
                          variant="determinate"
                          value={parseInt(percentage)}
                          sx={{
                            marginTop: '5px',
                            backgroundColor: 'rgb(241 245 249)', // Set color for unfilled part
                            '& .MuiLinearProgress-bar': {
                              backgroundColor: `${barcolor}` // Set color for filled part
                            }
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
              ) : (
                <Skeleton variant="rectangular" height={184} className="rounded-md" />
              )}
            </div>
          ) : (
            <img style={{ height: '392px' }} src={NoDataImg} alt="No data" />
          )}
        </Paper>
        <Paper elevation={3} sx={paperStyle}>
          {(maleData || femaleData) ? (
            <div className="flex w-full flex-col gap-1">
              <div className="flex items-center justify-center gap-2 w-full">
                <GroupIcon className="bg-[#444444] text-white rounded-full p-2 text-5xl" />
                <div className="w-full">
                  <p className="text-xl">Demographics Analytics</p>
                </div>
              </div>
              <div className="bg-slate-100 flex-grow overflow-y-auto h-[200px] p-2 rounded-lg scrollbar">
                <p className="text-xl font-semibold text-[#44BE54] mb-1">Male: {totalMale}</p>
                <div className="flex w-full h-6 bg-gray-300 rounded-full overflow-hidden">
                  {['kid', 'teen', 'adult', 'elderly'].map((ageGroup, index) => {
                    // Check if the age group exists in maleData, if not use 0
                    const ageValue = maleData[ageGroup] || 0;
                    const width = totalMale ? (ageValue / totalMale) * 100 : 0;
                    const colors = ['#A8E4B1', '#76D183', '#44BE54', '#247331'];
                    return (
                      <Tooltip
                        key={ageGroup}
                        title={<span className="text-lg p-2">{`${ageGroup}: ${maleData[ageGroup] || 0}`}</span>}
                        arrow
                        PopperProps={{
                          modifiers: [{ name: 'preventOverflow', enabled: true }]
                        }}
                        sx={{ fontSize: '1.2rem', padding: '8px' }}
                      >
                        <div
                          className="h-full"
                          style={{
                            width: `${width}%`,
                            backgroundColor: colors[index]
                          }}
                        ></div>
                      </Tooltip>
                    );
                  })}
                </div>

                {/* Male Legend */}
                <div className="flex justify-center gap-2 mt-2">
                  {['kid', 'teen', 'adult', 'elderly'].map((ageGroup, index) => {
                    const colors = ['#A8E4B1', '#76D183', '#44BE54', '#247331'];
                    return (
                      <div key={ageGroup} className="flex items-center gap-2">
                        <div className="size-3 rounded-full" style={{ backgroundColor: colors[index] }}></div>
                        <p className="text-sm">{ageGroup}</p>
                      </div>
                    );
                  })}
                </div>

                <p className="text-xl font-semibold text-[#FB1751] mt-3 mb-1">Female: {totalFemale}</p>
                <div className="flex w-full h-6 bg-gray-300 rounded-full overflow-hidden">
                  {['kid', 'teen', 'adult', 'elderly'].map((ageGroup, index) => {
                    // Check if the age group exists in femaleData, if not use 0
                    const ageValue = femaleData[ageGroup] || 0;
                    const width = totalFemale ? (ageValue / totalFemale) * 100 : 0;
                    const colors = ['#FD9DB5', '#FC5A83', '#FB1751', '#C2043A']; // Shades of pink
                    return (
                      <Tooltip
                        key={ageGroup}
                        title={<span className="text-lg p-2">{`${ageGroup}: ${femaleData[ageGroup] || 0}`}</span>}
                        arrow
                        PopperProps={{
                          modifiers: [{ name: 'preventOverflow', enabled: true }]
                        }}
                        sx={{ fontSize: '1.2rem', padding: '8px' }}
                      >
                        <div
                          className="h-full"
                          style={{
                            width: `${width}%`,
                            backgroundColor: colors[index]
                          }}
                        ></div>
                      </Tooltip>
                    );
                  })}
                </div>

                {/* Female Legend */}
                <div className="flex justify-center gap-2 mt-2">
                  {['kid', 'teen', 'adult', 'elderly'].map((ageGroup, index) => {
                    const colors = ['#FD9DB5', '#FC5A83', '#FB1751', '#C2043A'];
                    return (
                      <div key={ageGroup} className="flex items-center gap-2">
                        <div className="size-3 rounded-full" style={{ backgroundColor: colors[index] }}></div>
                        <p className="text-sm">{ageGroup}</p>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          ) : (
            <img className="w-80 h-80 ml-10 mb-10" src={NoDataImg} alt="No data" />
          )}
        </Paper>
        <Paper elevation={3} sx={paperStyleLastCard}>
          {interactionData && interactionData.length > 0 ? (
            <div className="flex  w-full  flex-col gap-1">
              <div className="flex items-center justify-center gap-2 w-full">
                {attended > 0 ? (
                  <InterpreterModeIcon className="bg-[#444444] text-white rounded-full p-2 text-5xl" />
                ) : (
                  <Skeleton variant="circular" width={60} height={45} />
                )}
                <div className="w-full">
                  {/* {footfallData ? <p><p> : <p>....<p> */}
                  {attended ? (
                    // <p className="text-3xl">To be edited</p>
                    <div className="w-full flex space-x-1">
                      <div className="w-1/2 flex flex-col text-center  rounded-md shadow-md bg-emerald-500 drop-shadow-md text-white">
                        <span>Attended</span>
                        <span className="text-2xl">{((attended / (attended + unAttended)) * 100).toFixed(1)}%</span>
                      </div>
                      <div className="w-1/2 flex flex-col text-center bg-red-500 rounded-md shadow-md drop-shadow-md text-white">
                        <span>Unattended</span>
                        <span className="text-2xl">{((unAttended / (attended + unAttended)) * 100).toFixed(1)}%</span>
                      </div>
                    </div>
                  ) : (
                    <Skeleton variant="rectangular" className="mb-3 rounded-sm" width={50} height={20} />
                  )}

                  {attended ? (
                    <p className="text-lg">Interactions</p>
                  ) : (
                    <Skeleton variant="rectangular" width={150} height={15} className=" mb-2 rounded-sm" />
                  )}
                </div>
              </div>
              {attended ? (
                <div className=" bg-slate-100 flex-grow overflow-y-auto h-[184px] p-2 rounded-lg scrollbar">
                  {interactionData.map((item, index) => {
                    return (
                      <div className="mt-2" key={index}>
                        <div className="flex gap-1 items-center">
                          <div
                            className=" rounded-full size-3"
                            style={{
                              // backgroundColor: `${item.colourHex}`
                              backgroundColor: '#06b6d4'
                            }}
                          >
                            {' '}
                          </div>
                          <div className="flex items-center gap-2">
                            <span className="mt-0.5">{item._id} : </span>
                            <div className="h-6  text-center px-2 border border-emerald-500 shadow-md rounded-md text-emerald-500 drop-shadow-md">
                              {((item.interacted / (item.interacted + item.not_interacted)) * 100).toFixed(1)}%
                            </div>
                            {item.not_interacted > 0 && (
                              <div className="h-6  border border-red-500 text-red-500 text-center px-2 shadow-md rounded-md drop-shadow-md">
                                {((item.not_interacted / (item.interacted + item.not_interacted)) * 100).toFixed(1)}%
                              </div>
                            )}
                          </div>
                        </div>
                        {/* <LinearProgress
                          variant="determinate"
                          value={percentage}
                          sx={{
                            marginTop: '5px',
                            backgroundColor: 'rgb(241 245 249)', // Set color for unfilled part
                            '& .MuiLinearProgress-bar': {
                              backgroundColor: `${barcolor}` // Set color for filled part
                            }
                          }}
                        /> */}
                      </div>
                    );
                  })}
                </div>
              ) : (
                <Skeleton variant="rectangular" height={184} className="rounded-md" />
              )}
            </div>
          ) : (
            <img style={{ height: '392px' }} src={NoDataImg} alt="No data" />
          )}
        </Paper>
      </Grid>

      {/* <div className="opacity-30">
        <Card
          sx={{
            marginTop: '0.5rem',
            padding: '0.5rem',
            borderRadius: '12px 12px 0 0'
          }}
        >
          <div
            style={{
              padding: '10px',
              textAlign: 'center',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}
          >
            <QuestionAnswerIcon className="bg-[#444444] text-white rounded-full p-2 text-5xl" />
            <div className="flex flex-col items-start pt-1">
              <h3 className="text-4xl">12</h3>
              <p>Message Logs</p>
            </div>
          </div>
        </Card>
        <Card sx={{ marginTop: '2px', padding: '0.5rem', borderRadius: '2px' }}>
          <div className="flex gap-3 mb-1">
            <AccountCircleIcon className="bg-[#444444] text-white rounded-full p-1 text-3xl" />
            <div className="flex flex-col gap-2">
              <div>has not interacted with a customer over 15 mins.</div>
              <div className="text-blue-500 cursor-pointer font-bold">View {'->'}</div>
            </div>
          </div>
          <div
            style={{
              textAlign: 'right'
            }}
          >
            08:02:53 30-01-2024
          </div>
        </Card>
        <Card sx={{ marginTop: '2px', padding: '0.5rem', borderRadius: '2px' }}>
          <div className="flex gap-3 mb-1">
            <AccountCircleIcon className="bg-[#444444] text-white rounded-full p-1 text-3xl" />
            <div className="flex flex-col gap-2">
              <div>
                Heavy customer traffic detected at Phone zone. Please re-assign <span className="font-bold">Ritesh Kumar</span> to Phones
                zone for optimal customer - employee ratio.
              </div>
              <div className="text-blue-500 cursor-pointer font-bold">View {'->'}</div>
            </div>
          </div>
          <div
            style={{
              textAlign: 'right'
            }}
          >
            08:02:53 30-01-2024
          </div>
        </Card>
        <Card sx={{ marginTop: '2px', padding: '0.5rem', borderRadius: '0 0 12px 12px' }}>
          <div className="flex gap-3 mb-1 ">
            <AccountCircleIcon className="bg-[#444444] text-white rounded-full p-1 text-3xl" />
            <div className="flex flex-col gap-2">
              <div>Loyal customer 3330123 detected at entry gate.</div>
              <div className="text-blue-500 cursor-pointer font-bold">View {'->'}</div>
            </div>
          </div>
          <div
            style={{
              textAlign: 'right'
            }}
          >
            <p>08:02:53 30-01-2024</p>
          </div>
        </Card>
      </div> */}
    </>
  );
}

export default Rightbar;
